import { useTranslation } from 'react-i18next';
import ShrugBro from '../../../../assets/images/home/running-activities/Shrug-bro.svg';
const NoRunningActivities = () => {
	const { t } = useTranslation();

	return (
		<div className="flex h-full items-center justify-center">
			<div>
				<img src={ShrugBro} alt="ShrugBro" />
				<div className="text__default mt-2 p-4 text-center font-manropeBold text-xl text-[#AFAFAF]">{t("no_upcoming_activities")}</div>
			</div>
		</div>
	);
};

export default NoRunningActivities;
